<!--
@Create By Tim For 19/08/16
@课件评论组件
-->
<template>
  <div class="CourseComment" v-loading="loading">
    <!-- 评论顶部 -->
    <div class="commentTitle">
      <!-- 好评率 -->
      <div class="grade">
        <p>{{ commentListType.positiveRating }}%</p>
        好评率
      </div>
      <!-- 选择评论 -->
      <div class="changeComment">
        <el-radio-group v-model="geade" @change="choiceComment">
          <el-radio :label="0">全部（{{ commentListType.geade }}）</el-radio>
          <el-radio :label="5">五星（{{ commentListType.geade5 }}）</el-radio>
          <el-radio :label="4">四星（{{ commentListType.geade4 }}）</el-radio>
          <el-radio :label="3">三星（{{ commentListType.geade3 }}）</el-radio>
          <el-radio :label="2">二星（{{ commentListType.geade2 }}）</el-radio>
          <el-radio :label="1">一星（{{ commentListType.geade1 }}）</el-radio>
        </el-radio-group>
      </div>
    </div>

    <!-- 评论列表 -->
    <div class="commentList">
      <!-- 单条评论 -->
      <div class="singleComment" v-for="(item, index) in commentList" :key="index">
        <!-- 评论者头像和名字 -->
        <div class="singleCommentPhoto">
          <img src="../../../static/image/user.jpg" />
          <br />
          {{ item.createBy }}
        </div>
        <!-- 评论内容，评分，时间 -->
        <div class="commentContent">
          <!-- 评分 -->
          <div class="commentContentRage"><el-rate disabled v-model="item.geade" :colors="colors"></el-rate></div>

          <!-- 留言 -->
          <p class="commentContentTxt">{{ item.comment }}</p>

          <p class="commentContentTime">
            已上课43小时39分钟时评价 
            <span>{{ item.createTime }}</span>
          </p>
        </div>
      </div>
      <!-- 单条评论 -->
    </div>

    <div class="commentNull" v-if="!hidePagination">暂无评论...</div>

    <!-- 用户发表评论 -->
    <div class="addComment">
      <p>发表评论</p>
      <p><el-rate v-model="rateData"></el-rate></p>
      <el-input type="textarea" :rows="4" placeholder="说点什么吧..." v-model.trim="commentData"></el-input>
      <el-button @click="commitComment" :disabled="isSubmitComment" style="float:right; margin-top: 15px;" type="primary">发布评论</el-button>
    </div>
    <!-- 评论分页组件 -->
    <div class="pagination" v-if="hidePagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="currentPage"
        :total="totals"
        @current-change="currentChange"
        @prev-click="prevClick"
        @next-click="nextClick"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import api from '../../../config/api';

export default {
  name: 'CourseComment',
  data() {
    return {
      // 是否显示分页组件
      hidePagination: false,
      // 加载框
      loading: false,
      // 已选择的评论类型
      geade: 0,
      // 评论星级
      rage: 5,
      // 评论星级颜色
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      // 每页展示几条
      pageSize: 5,
      // 总数
      totals: 0,
      // 当前页码
      currentPage: 1,
      // 当前课程ID
      courseId: this.$route.params.id,
      // 评论列表集合
      commentList: [],
      // 各个评论类型条数以及好评率
      commentListType: '',
      // 发表评论
      commentData: '',
      // 评论评分
      rateData: 5
    };
  },

  created() {},

  mounted() {
    this.getData();
    this.getCommentsType();
  },

  computed: {
    // 判断是否写了评论， 放开提交按钮
    isSubmitComment() {
      return this.commentData.length === 0;
    }
  },

  methods: {
    // 获取评论分类
    getCommentsType() {
      this.$axios.get(api + 'portal/discuss/count?courseId=' + this.courseId).then(res => {
        this.commentListType = res;
      });
    },
    // 获取评论
    getData() {
      this.loading = true;
      this.$axios.get(api + 'portal/discuss/list?courseId=' + this.courseId + '&pageNum=' + this.currentPage + '&pageSize=10&geade=' + this.geade).then(res => {
        this.loading = false;
        if (res && res.rows && res.rows.length > 0) {
          this.hidePagination = true;
          this.commentList = res.rows;
          this.totals = res.total;
        } else {
          this.hidePagination = false;
          this.commentList = [];
        }
      });
    },
    // 点击页码时事件
    currentChange(pageCount) {
      this.currentPage = pageCount;
      this.getData();
    },
    // 点击上一页时事件
    prevClick(pageCount) {
      this.currentPage = pageCount;
      this.getData();
    },
    // 点击下一页时事件
    nextClick(pageCount) {
      this.currentPage = pageCount;
      this.getData();
    },

    // 选择评论
    choiceComment(value) {
      console.log(value);
      this.geade = value;
      this.getData();
    },

    // 发布评论
    commitComment() {
      let data = {
        comment: this.commentData,
        courseId: this.$route.params.id,
        geade: this.rateData
      };
      this.$axios.post(api + 'portal/discuss', data).then(res => {
        this.commentData = '';
        this.rateData = 5;
        this.getData();
        this.getCommentsType();
      });
    }
  }
};
</script>

<style>
.CourseComment .commentTitle .changeComment .el-radio {
  width: 100px;
  margin-right: 10px;
}

.CourseComment .commentTitle .changeComment .el-radio .el-radio__label {
  padding-left: 5px;
}

</style>

<style scoped>
.CourseComment {
  background: #fff;
}

.CourseComment .commentTitle {
  padding: 10px 20px;
  background: #f4f4f4;
  border: 1px solid #e6e6e6;
  overflow: hidden;
}

.CourseComment .commentTitle .grade {
  float: left;
  border-right: 2px solid #d8d8d8;
  font-size: 14px;
  color: #000;
  padding-right: 15px;
  margin-right: 30px;
}

.CourseComment .commentTitle .grade p {
  font-size: 18px;
  color: #ff0000;
  margin-bottom: 5px;
}

.CourseComment .commentTitle .changeComment {
  float: left;
  height: 48px;
  line-height: 48px;
}

.CourseComment .singleComment {
  padding: 20px 0;
  background: #fff;
  border-bottom: 1px solid #e2e2e2;
  overflow: hidden;
}

.CourseComment .singleComment .singleCommentPhoto {
  float: left;
  width: 60px;
  color: #666;
  text-align: center;
  margin-right: 10px;
}

.CourseComment .singleComment .singleCommentPhoto img {
  width: 46px;
  height: 46px;
  border-radius: 23px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.CourseComment .singleComment .commentContent {
  margin-left: 70px;
}

.CourseComment .singleComment .commentContent .commentContentRage {
  margin-bottom: 5px;
}

.CourseComment .singleComment .commentContent .commentContentTxt {
  font-size: 14px;
  color: #333;
  line-height: 20px;
  margin-bottom: 15px;
}

.CourseComment .singleComment .commentContent .commentContentTime {
  font-size: 14px;
  color: #999;
}

.CourseComment .singleComment .commentContent .commentContentTime span {
  margin-left: 100px;
}

.CourseComment .pagination {
  margin: 30px 0;
  text-align: center;
}

.CourseComment .commentNull {
  width: 100%;
  height: 150px;
  line-height: 150px;
  text-align: center;
  font-size: 14px;
  color: #333;
}

.CourseComment .addComment {
  margin-top: 30px;
  overflow: hidden;
}

.CourseComment .addComment p {
  font-size: 14px;
  color: #333;
  margin: 0 0 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/CourseInfo/CourseComment.vue